import { postData } from '/01_fundaments/utilities/api';
import { LOGIN_CODE } from '/01_fundaments/utilities/fieldNames';

export async function initResetPassword(csrfToken, loginID) {
  return postData('/account/init_reset_password', csrfToken, { loginID })
    .then(response => response.json());
}

export async function resetPassword(passwordResetToken, newPassword) {
  return postData('/account2/reset_password', '', { passwordResetToken, newPassword })
    .then(response => response.json());
}

export async function isLoginIDAvailable(csrfToken, loginID) {
  return postData('/account/is_available', csrfToken, { loginID })
    .then(response => response.json());
}

export async function register(csrfToken, email, password) {
  return postData('/account/register', csrfToken, { email, password })
    .then(response => response.json());
}

export async function linkAccount(csrfToken, loginID, password, regToken) {
  return postData('/account/link_account', csrfToken, { loginID, password, regToken })
    .then(response => response.json());
}

export async function linkEmail(csrfToken, regToken, email) {
  return postData('/account/link_email', csrfToken, { regToken, email })
    .then(response => response.json());
}

export async function login(csrfToken, loginID, password) {
  const clientId = window.backendData.clientId;
  const loginCode = (window.backendData.subProfileLogin || {})[LOGIN_CODE] || undefined;
  return postData('/perform_login', csrfToken, { loginID, password, clientId, loginCode })
    .then(response => response.text())
    .then(text => text ? JSON.parse(text) : {});
}

export async function socialLogin(csrfToken, provider, redirectUri, state, loginMode, regToken) {
  const clientId = window.backendData.clientId;
  const loginCode = (window.backendData.subProfileLogin || {})[LOGIN_CODE] || undefined;
  let requestBody = { provider, clientId, redirectUri, state, loginCode };
  if (loginMode && regToken) {
    requestBody = { ...requestBody, regToken, loginMode };
  }
  return postData('/account/init_social_login', csrfToken, requestBody)
    .then(response => response.text())
    .then(text => text ? JSON.parse(text) : {});
}
